import axios from "axios";
import React, { useEffect, useState } from "react";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { Link } from "react-router-dom";
import $ from "jquery";
import { Helmet } from "react-helmet";

export default function Brands() {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'

  const [brands, setbrands] = useState(null);
  const [current, setcurrent] = useState(1);
  const [pageNums, setpageNums] = useState("");

  function currentPage(page) {
    $(".pagination .bgMain").removeClass("bgMain");
    $(`#page${page - 1}`).addClass("bgMain");
  }

  async function getBrands(page) {
    let { data } = await axios.get(`${baseURL}/api/v1/brands`, {
      params: { limit: 15, page: page },
    });
    setbrands(data.data);
    setpageNums(data.metadata.numberOfPages);
    setcurrent(page);
    currentPage(page);
  }
  let pages = new Array(pageNums).fill(1).map((_, idx) => idx + 1);

  useEffect(() => {
    getBrands(1);
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fresh Cart Brands</title>
      </Helmet>
      {brands ? (
        <>
          {/* Display Loading screen till fetching data then display it */}
          <div className="row my-5 align-items-center">
            <div className="col-md-3">
              <div className="intro ">
                <h2 className=" fw-bolder fs-1 text-main">Our Brands</h2>
                <p className=" text-text-muted font-sm ">
                  You can see our brands and each brand products{" "}
                </p>
              </div>
            </div>
            {brands.map((brand, idx) => (
              <div key={idx} className=" col-md-3">
                <div className="product cursor-pointer px-2 py-3">
                  <Link to={`/branddetails/${brand._id}`}>
                    <img className="w-100" src={brand.image} alt={brand.name} />
                    <h2 className=" fw-bold h6 text-center text-main">
                      {brand.name}
                    </h2>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* Handle pagination of Brands pages */}
          <nav aria-label="Page navigation example">
            <ul className="pagination d-flex justify-content-center">
              <li className="page-item ">
                <span
                  className="page-link Btn cursor-pointer"
                  aria-label="Previous"
                  onClick={() => getBrands(current - 1)}
                >
                  <span aria-hidden="true">&laquo;</span>
                </span>
              </li>
              {pages.map((page, idx) => (
                <li key={idx} className="page-item bg-main">
                  <span
                    id={`page${page}`}
                    onClick={() => getBrands(page)}
                    className={`page-link customSpan Btn cursor-pointer ${
                      current === page ? "bgMain" : ""
                    }`}
                  >
                    {page}
                  </span>
                </li>
              ))}
              <li className="page-item">
                <span
                  className="page-link Btn cursor-pointer"
                  aria-label="Next"
                  onClick={() => getBrands(current + 1)}
                >
                  <span aria-hidden="true">&raquo;</span>
                </span>
              </li>
            </ul>
          </nav>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}
